import ActividadCuaterniones from "@/views/Cuaterniones/ActividadCuaterniones.vue";
import Cuaterniones from "@/views/Cuaterniones/Cuaterniones.vue";
import CuestionarioCuaterniones from "@/views/Cuaterniones/CuestionarioCuaterniones.vue";
import DemostacionCuaterniones from "@/views/Cuaterniones/DemostacionCuaterniones.vue";
import IngresoHome from "@/views/IngresoHome.vue";
import Intro from "@/views/Intro.vue";
import MenuModulos from "@/views/MenuModulos.vue";
import Perfil from "@/views/Perfil.vue";
import Resultados from "@/views/Resultados.vue";
import ActividadSistemaCoordenadas from "@/views/SistemasCoordenadas/ActividadSistemaCoordenadas.vue";
import CuestionarioSistemaCoordenadas from "@/views/SistemasCoordenadas/CuestionarioSistemaCoordenadas.vue";
import DemostacionSistemaCoordenadas from "@/views/SistemasCoordenadas/DemostacionSistemaCoordenadas.vue";
import SistemaCoordenadas from "@/views/SistemasCoordenadas/SistemaCoordenadas.vue";
import ActividadTransformadas3D from "@/views/Transformadas3D/ActividadTransformadas3D.vue";
import CuestionarioTransformadas3D from "@/views/Transformadas3D/CuestionarioTransformadas3D.vue";
import DemostracionTransformadas3D from "@/views/Transformadas3D/DemostracionTransformadas3D.vue";
import Transformadas3D from "@/views/Transformadas3D/Transformadas3D.vue";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Ingreso",
    component: IngresoHome,
  },
  {
    path: "/home",
    name: "Intro",
    component: Intro,
  },
  {
    path: "/menu",
    name: "Menu",
    component: MenuModulos,
  },
  {
    path: "/resultados",
    name: "Resultados",
    component: Resultados,
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: Perfil,
  },
  {
    path: "/sistema-de-coordenadas",
    name: "SistemaCoordenadas",
    component: SistemaCoordenadas,
  },
  {
    path: "/demostracion-sistema-de-coordenadas",
    name: "DemostacionSistemaCoordenadas",
    component: DemostacionSistemaCoordenadas,
  },
  {
    path: "/actividad-sistema-de-coordenadas",
    name: "ActividadSistemaCoordenadas",
    component: ActividadSistemaCoordenadas,
  },
  {
    path: "/cuestionario-sistema-de-coordenadas",
    name: "CuestionarioSistemaCoordenadas",
    component: CuestionarioSistemaCoordenadas,
  },
  {
    path: "/transformadas-3d",
    name: "Transformadas3D",
    component: Transformadas3D,
  },
  {
    path: "/demostracion-transformadas-3d",
    name: "DemostracionTransformadas3D",
    component: DemostracionTransformadas3D,
  },
  {
    path: "/actividad-transformadas-3d",
    name: "ActividadTransformadas3D",
    component: ActividadTransformadas3D,
  },
  {
    path: "/cuestionario-transformadas-3d",
    name: "CuestionarioTransformadas3D",
    component: CuestionarioTransformadas3D,
  },
  {
    path: "/cuaterniones",
    name: "Cuaterniones",
    component: Cuaterniones,
  },
  {
    path: "/demostracion-cuaterniones",
    name: "DemostracionCuaterniones",
    component: DemostacionCuaterniones,
  },
  {
    path: "/actividad-cuaterniones",
    name: "ActividadCuaterniones",
    component: ActividadCuaterniones,
  },
  {
    path: "/cuestionario-cuaterniones",
    name: "CuestionarioCuaterniones",
    component: CuestionarioCuaterniones,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
